import React from 'react';
import { connect } from 'react-redux';
import store from '../store';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
import { addUser, listUsers } from '../actions/user';
import { Button, IconButton, Input, InputGroup } from 'rsuite';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
import PlusIcon from '@rsuite/icons/Plus';

class UserAdd extends React.Component {
  constructor() {
      super();
      this.state = {
        name: '',
        email: '',
        modal: false,
        password: '',
        password_confirm: '',
        passwordVisible: false,
        organizations: [],
        errors: {}
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.showModal = this.showModal.bind(this);
      this.hideModal = this.hideModal.bind(this);
  }

  showModal(event) {
    this.setState({modal: true});
  };
  hideModal(event) {
    this.setState({modal: false});
  };


  handleInputChange(n, v ) {
      this.setState({
          [n]: v
      })
  }

  handlePasswordVisible(e) {
    const s = parseInt(e.currentTarget.getAttribute('state'));
    let v = false;
    if (s === 0) {
      v = true;
    }
    this.setState({
      passwordVisible: v
    })
  }

  handleSubmit(e) {
      e.preventDefault();
      let currentorg = localStorage.getItem('currentorg');
      // console.log('currrrrrrrrrrrrrr', localStorage.getItem('currentorg'));
      const user = {
          name: this.state.name,
          email: this.state.email,
          password: this.state.password,
          password_confirm: this.state.password_confirm,
          organizations: [localStorage.getItem('currentorg')],
          // organizations: this.state.organizations,
          passwordVisible: false,
          organizations: currentorg,
          // organizations: ['63b4482766d52eb74d471210', '63b454d563887f3e4fc74a2a'],
          errors: {}
      }
      this.props.addUser(user, this.props.history);
      this.props.listUsers('dada', currentorg, this.props.history);

  }

    render() {
      const { errors } = this.state;

        return (
        <div>
          <div className="button-container" onClick={this.showModal}>
            <IconButton
              appearance="primary"
              className="iron-button add"
              icon={<PlusIcon />}
              >Dodaj użytkownika</IconButton>
          </div>
          <div className={`modal-over add ${this.state.modal === true? 'opened': ''}`}>
            <div className="modal">
              <div className="modal-header">
              <div className="title">
              Dodaj użytkownika
              </div>
              <div className="close-button">
                <button onClick={this.hideModal} id="modal-btn-close" className="on"><span></span><span></span><span></span>
                </button>
              </div>
              </div>
              <form onSubmit={ this.handleSubmit }>
                <div className="form-group">
                    <Input
                    type="text"
                    placeholder="Name"
                    autoComplete="name"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.name
                    })}
                    name="name"
                    onChange={value => {
                      this.handleInputChange('name', value);
                    }}
                    value={ this.state.name }
                    />
                    {errors.name && (<div className="invalid-feedback">{errors.name}</div>)}
                </div>
                <div className="form-group">
                    <Input
                    type="email"
                    placeholder="Email"
                    autoComplete="email"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.email
                    })}
                    name="email"
                    onChange={value => {
                      this.handleInputChange('email', value);
                    }}
                    value={ this.state.email }
                    />
                    {errors.email && (<div className="invalid-feedback">{errors.email}</div>)}
                </div>
                <div className="form-group">
                  <InputGroup inside>
                    <Input
                    type={this.state.passwordVisible ? 'text' : 'password'}
                    placeholder="Password"
                    autoComplete="current-password"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.password
                    })}
                    name="password"
                    onChange={value => {
                      this.handleInputChange('password', value);
                    }}
                    value={ this.state.password }
                    />
                    {errors.password && (<div className="invalid-feedback">{errors.password}</div>)}
                    <InputGroup.Button state={this.state.passwordVisible ? 1 : 0} onClick={this.handlePasswordVisible}>
                      {this.state.passwordVisible ? <EyeIcon /> : <EyeSlashIcon />}
                    </InputGroup.Button>
                  </InputGroup>
                </div>
                <div className="form-group">
                  <InputGroup inside>
                    <Input
                    type={this.state.passwordVisible ? 'text' : 'password'}
                    placeholder="Confirm Password"
                    autoComplete="current-password"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.password_confirm
                    })}
                    name="password_confirm"
                    onChange={value => {
                      this.handleInputChange('password_confirm', value);
                    }}
                    value={ this.state.password_confirm }
                    />
                    {errors.password_confirm && (<div className="invalid-feedback">{errors.password_confirm}</div>)}
                    <InputGroup.Button state={this.state.passwordVisible ? 1 : 0} onClick={this.handlePasswordVisible}>
                      {this.state.passwordVisible ? <EyeIcon /> : <EyeSlashIcon />}
                    </InputGroup.Button>
                  </InputGroup>
                </div>
                  <div className="form-group">
                      <IconButton
                        appearance="primary"
                        type="submit"
                        className="iron-button"
                        icon={<PlusIcon />}

                        >
                          Dodaj użytkownika
                      </IconButton>
                  </div>
              </form>
            </div>
          </div>
        </div>
        );
    }
}

UserAdd.propTypes = {
    addUser: PropTypes.func.isRequired,
    listUsers: PropTypes.func.isRequired
};


const mapStateToProps = state => ({
  orgcurrent: state.orgcurrent,
  errors: state.errors
});

export default connect(mapStateToProps,{ addUser, listUsers })(withRouter(UserAdd))
